
import React, { useState } from 'react';
import { data } from './dataMap';
import ConnectButtonMapItem from './ConnectButtonMapItem';
import './stylesMap.scss'


export default function ViewAerialMapMenu ( { zoomInFunc, zoomOutFunc } ) {
    const [zoomInSrc, setZoomInSrc] = useState('img/location-map/icon--zoom-in.png');
    const [zoomOutSrc, setZoomOutSrc] = useState('img/location-map/icon--zoom-out.png');
    const menuItems = [];
    let currMenuGroup;
    let currMenuItem;
    let currIndex = 0;
    for (let i = 0; i < data.length; i++) { 
        currMenuGroup = data[i].options;
        menuItems.push(
            <h2 className='aerial-map--title' key={ currIndex }>{ data[i].title }</h2>
        );
        currIndex++;
        for (let j = 0; j < currMenuGroup.length; j++) { 
            currMenuItem = currMenuGroup[j];
            menuItems.push(
                <ConnectButtonMapItem key={currIndex } item={ currMenuItem.title } />
            );
            currIndex++;
        }
    }

    return (
        <div className='aerial-map--menu'>
            <div className='aerial-map--menu-options'>
                { menuItems }
            </div>
            <div className='aerial-map--zoom-tools'>
            <p className='aerial-map--title'>Zoom</p>

                <button onMouseEnter={() => setZoomInSrc('img/location-map/icon--zoom-in-selected.png')} onMouseOut={() => setZoomInSrc('img/location-map/icon--zoom-in.png')} onClick={ zoomInFunc }><img src={zoomInSrc} width='43' height='43' alt='Zoom In icon' /></button>
                <button onMouseEnter={() => setZoomOutSrc('img/location-map/icon--zoom-out-selected.png')} onMouseOut={() => setZoomOutSrc('img/location-map/icon--zoom-out.png')}onClick={ zoomOutFunc }><img src={zoomOutSrc} width='43' height='43' alt='Zoom Out icon' /></button>
            
            </div>
        </div>
    );

}